import React from 'react';

export type FlashMessageProps = {
  message? : string;
  type? : 'alert' | 'notice';
};

const FlashMessage = ({ message, type }: FlashMessageProps) => (
  // fa icon automatically added by packs/application.js and Flash.js
  <div className={type} id="flash">
    <p>{`${message}`}</p>
  </div>
);

export default FlashMessage;
